var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWatermarkingPlaylistsEmptyState = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 170,
  height: 129,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E5EBF0",
  d: "M108 13C92-5 61-3 45 10 28 23 38 37 8 78c-15 20-11 49 28 50 42 1 111 8 116-46 4-37-24-47-44-69"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1A1A1A",
  d: "m46 51 5-3 4-4c3 0 6 8 8 9l-7 9z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m56 62 38-48v-1h-1L55 62 17 13v1l38 48-38 49 38-48 38 48 1 1v-1z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#1A1A1A",
  d: "M29 110s0-2 2-3l5-6 6-9c3-2 5-4 6-7l7-11c2 0 2 3 3 4l5 6c1 2 3 7 5 8 2 0 4 3 6 7s5 5 8 11z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#5f63ee",
  d: "M32 32 17 14v-1z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#1A1A1A",
  d: "M55 66v-1h1v1zm0 3v-1h1v1zm0 3v-1h1v1zm37 37H17c-3 0-5 3-5 6v2h85v-2c0-3-2-6-5-6"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#5f63ee",
  d: "M67 117c-4-2-10-4-18-3-10 0-16 2-18 3h-1l1 1c2-1 8-3 18-4a34 34 0 0 1 18 4z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#5f63ee",
  d: "M97 113v-1zc-5 2-9 4-15 2-6-3-8-3-15-4l-5-2h20-53 14c-1 3-5 4-13 4v1c8-1 13-2 14-5h4v1l5 1 9 2 9 2 7 2c-1-2-3-2-7-2l-9-2-9-3-4-1h13c1 2 2 3 5 3 7 0 9 1 15 3a14 14 0 0 0 8 1z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#5f63ee",
  d: "M82 112c0 1 2 2 5 2l5-2-5-2c-3 0-5 1-5 2m5-1 4 1-4 1-5-1zM67 7h-9z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M79 95c2-2 2-5 2-8 0-4 0-7-2-9 0 0-2 4-2 9 0 6 2 8 2 8m42-33-3 3-4 22 2-1 4-23z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m77 104 11-5h-3c-5-1-8-4-8-11s4-13 4-13 5-2 11 1c5 2 7 2 9 5 0 0-1 2-3 2l-1 1a79 79 0 0 0 8 1l2-5 2-3 1-11s-4 0-6-2l-2-5s-5 0-8 2c-4 1-6 3-9 5l-9 10-7 14c-1 3-3 10-3 16l-1 6z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#5f63ee",
  d: "M107 75v-1l-1-2a3 3 0 0 1 3-4v1a3 3 0 0 0-3 3l2 2zm-11-8c-3 0-5-2-5-5h1a5 5 0 1 0 8-3l1 3c0 2-2 5-5 5m-2 9h-1a5 5 0 0 1 10-1c-1-2-3-3-5-3s-4 2-4 4m-3 0v-2a3 3 0 0 0-7 0v1l-1-1a4 4 0 1 1 8 1zm-12 24a4 4 0 0 1-2-9v1a4 4 0 1 0 5 6v-1 1zm-6 6a6 6 0 0 0-7-3v-1h1c2 0 5 2 6 4"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#5f63ee",
  d: "M69 94h-1v-1h1a6 6 0 0 0 3-11v-1h1a7 7 0 0 1-4 13"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5EBF0",
  d: "M160 111h-2l-43-6-5 4c-6 7-11 8-11 8h60c2-1 1-5 1-6"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m113 107 48 5-1-1-45-6z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#1A1A1A",
  d: "m169 104-5 3-2 1h1v-3l-1-1-1 2-2-2h-1c-1 1 1 5 2 7l-12-2-33-5v1l-3 3c-6 6-12 8-13 9h-2 68l4-12zm-10 0c1 1 2 3 1 6-1-2-2-5-1-6m-40 10c-2 0-6-2-6-5l2-4 35 5 8 1-1 6h-32c1-2-2-2-6-3m40 3h-1v-6h2c0 1 1 4-1 6m2-8 1-4c1 1 0 4-1 5z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#5f63ee",
  d: "m141 111 3 2h3l3-1-5-5z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5EBF0",
  d: "m147 108-11-12s-10-12-14-12l-6 2-12 6-7 4s-4 3-9 3l-12 5-8 5 3 6 4 3 9 1 11-1 5-2 6-3 14-13 16 12 5-1 3 2 3 1 3-2-2-3"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m126 86-4-2a17 17 0 0 0-4 1l-2 1-12 6h5l10-5c2-1 5-1 6 1l19 20 2-1z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#1A1A1A",
  d: "M84 101v-1l-1 1s1 8-2 9v1l2 1 2-6z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m140 111-18-19c-1-1-3-2-5 0a396 396 0 0 1-29 20l-5-1 2-5-1-5v-1l-1 1s2 3 1 5l-1 5-4-2-4-4h-1v1l4 3 8 3h2c5-1 22-14 29-20h5l17 19z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#1A1A1A",
  d: "m146 107-4 4h-1z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#5f63ee",
  d: "M164 111h-1v1l2 3v-1zm2-1-1-2h-1v1l1 2 1 1v-2"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m121 52-2-1-1 1c-1 1 0 1 1 2z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#1A1A1A",
  d: "M120 51h-1l-2 1 1 1h1l2-1zm-1 2-1-1h1zm-4-1-1-1q1.5 0 0 0 0-1.5 0 0h-1v1h1v-1 1z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#1A1A1A",
  d: "m156 114-4-2 2-1 2-1v-1h-2l1-3h-1c-1-1-3 4-4 5l-23-24c-3-3-6-4-10-2l3-21 1-1 1-2v-3l-1-1 1-1v-1l2-1-2-1v-1l-1-4 1-3-1-3h-5a12 12 0 0 0-2 1l-2 1 1-1a6 6 0 0 0-4 1l-1-1h-1l1 1h-1v1l-1 1v5a7 7 0 0 0 1 3l-4 4-7 2c-3 1-8 3-14 8-5 5-9 11-12 19s-5 17-5 25l1 2h4l3 3c2 2 6 2 10 2h8a31 31 0 0 0 20-10l9-8 6 5 10 7 5-2 2 2-1 4h17s0-2-3-3m-34-55v2l-2 2-4 23-3 1s-2-2-5-2h-2l3-8 1-1 1-3 6-12v-1 1h2l1-1v1l1-2-1 1v-1l1-1zM95 88h1s2-3 6-3h6l5 2-9 4v1l-6 3-3 2-5 2-6-1a11 11 0 0 1-4-2c-2-2-3-4-3-7a26 26 0 0 1 4-14h9v1c4 1 6 3 8 5l-1 3zm15-13v-9l2-3 2-4 3 1-1 1-5 12zm-3-20 3 1 2-1h1v-4l1-1h1l1 1h1l3-3 1 4 1 1 1 1-1 1-1 1v1h-3l1 1 1-1c0 2-1 3-2 3l-5-2h-1s1 2-1 5l-1 3h-1l-3-1-3-6zm-16 8a33 33 0 0 1 11-4l3 6 5 2-6 17h-6v-1h1l2-1 4-11h-1l-3 10-8-5c-7-3-10-2-12-2l6-9zm-23 46-2 3c0-9 1-17 4-25a51 51 0 0 1 17-22c-2 2-5 5-7 11-4 9-4 16 0 20l2 2 3 2h-1a81 81 0 0 0-16 9m73 1c-2 2-5 2-5 2l-9-7 1-1h-1l-1-2h-1 1v-1l-1-1-2-2h-1l-2 2-9 9-3 2a30 30 0 0 1-17 7c-11 1-16 0-18-1l-3-4-2-3 4-3 14-7 3 1 10-5 5-4 13-6c4-2 7-2 10 1l18 20zm8 2a6 6 0 0 1-2 1 6 6 0 0 1-3 0l-2-2 3-2 1-2 4 4zm5-6h1l-4 5zm-3 5h1l4-2z"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#5f63ee",
  d: "m148 117 2-2v-1h-1l-3 3zm1 0h2v-1l2-1v-1h-1l-2 2z"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M88 16h-5L63 47v1h1l24-31zM38 90l-14 16v1h4l10-16zm39-68v-1h-3v1l-4 7h2z"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "#1A1A1A",
  d: "M97 6H13v3c0 3 2 5 5 5h74c3 0 5-2 5-5z"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#5f63ee",
  d: "M48 15v-1l5-2c2 0 5 0 9-2l9-2c3 0 6 0 7-2-1 2-4 2-7 3l-9 2-9 2-4 1zm-5 0v-1c-1-4-16-5-30-3v-1h17c8 0 13 2 14 4v1zm8-5h-2c-5 0-13-1-18-4l18 3c8 1 14-1 17-3h1c-4 2-9 4-16 4m11 5h-1v-1l5-2 16-4 8-1 7 3v1h-1c-4-3-8-5-14-2-6 2-8 3-15 3-3 0-4 1-5 3"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "#5f63ee",
  d: "M87 13c-3 0-5-1-5-2l5-1 5 1zm0-3-5 1 5 1 4-1z"
})));
export default SvgWatermarkingPlaylistsEmptyState;